import { withInstall } from '@jdesign-vue/utils'

import Space from './src/space'

export const JdSpace = withInstall(Space)
export default JdSpace

export * from './src/space'
export * from './src/item'
export * from './src/use-space'
